import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import Section from '../ui/Section';
import { CheckCircle } from 'lucide-react';

const About = () => {
    const { t } = useLanguage();

    const titleParts = t.about.title.split(' ');
    const firstPart = titleParts[0];
    const secondPart = titleParts.slice(1).join(' ');

    return (
        <Section id="about" background="white">
            <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
                        {firstPart} <span className="text-gold-600">{secondPart}</span>
                    </h2>
                    <p className="text-slate-600 mb-6 text-lg leading-relaxed">
                        {t.about.description}
                    </p>
                    <p className="text-slate-600 mb-8 text-lg leading-relaxed">
                        {t.about.mission}
                    </p>
                    <div className="space-y-4">
                        {t.about.areas.map((item, index) => (
                            <div key={index} className="flex items-center gap-3">
                                <CheckCircle className="text-gold-500 w-6 h-6 flex-shrink-0" />
                                <span className="text-slate-700 font-medium">{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="relative h-[400px] rounded-lg overflow-hidden shadow-xl">
                    <img
                        src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1931&auto=format&fit=crop"
                        alt="Civil Engineer at work"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>
            </div>
        </Section>
    );
};

export default About;
